<template>
  <div class="q-edit-content q-checkbox">
    <vh-checkbox-group
      v-model="valArray"
      @change="change"
      class="checkbox-items"
    >
      <draggable
        ref="drag"
        @update="moved"
        v-model="value.detail.list"
        :options="{handle: '.sort-item', animation: 200}"
        @start="drag = true"
        @end="drag = false"
      >
        <div
          v-for="(item, index) in value.detail.list"
          :key="index"
          class="row"
          :class="{row_edit: value.ext.edit}"
        >
          <vh-checkbox
            class="q-select-item"
            :disabled="isReplay"
            :class="{display: !value.ext.edit}"
            :label="item.key ? item.key : index"
            :key="index"
          >
            <div class="sort-item" v-if="value.ext.edit">
              <img
                width="8"
                src="https://cnstatic01.e.vhall.com/upload/interacts/screen-imgs/202404/4e/00/4e0048314a03b356b433a19a7e41584a9065.png"
                alt=""
                style="cursor: move"
              />
            </div>
            <com-input
              v-if="value.ext.edit"
              :placeholder="$t('form.form_1041')"
              class="chose-item"
              :class="{error: item.error}"
              @focus="itemFocus(item)"
              v-model="item.value"
              :max-length="100"
            ></com-input>
            <div
              v-if="!value.ext.edit"
              class="item-text check-item"
              v-text="item.value"
            ></div>
          </vh-checkbox>
          <!-- 其他选项input框 -->
          <com-input
            com-input
            v-if="
              item.custom_opt == 1 &&
              (valArray.includes(item.key) || value.ext.edit)
            "
            :placeholder="$t('quest.k_3201')"
            class="otherItem"
            v-model.trim="otherValue"
            :disabled="isReplay"
            :show-length="!isReplay"
            :max-length="100"
          ></com-input>
          <span
            class="remove"
            v-if="value.ext.edit && value.detail.list.length > 2"
            @click.stop="delItem(index)"
          >
            <i class="vh-icon-remove-outline"></i>
          </span>
        </div>
      </draggable>
    </vh-checkbox-group>
    <div v-if="!value.ext.edit && errorTip" class="error-msg">
      {{ errorTip }}
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import ComInput from "../input/com.vue";
export default {
  name: "qCheckbox",
  components: {
    draggable,
    "com-input": ComInput,
  },
  props: {
    value: {
      type: Object,
      default() {
        return {};
      },
    },
    isReplay: Boolean,
  },
  data() {
    return {
      errorTip: "",
      valArray: [],
      otherValue: "",
      drag: false,
    };
  },
  methods: {
    delItem(index) {
      if (this.value.detail.list[index].custom_opt == 1) {
        delete this.value.custom_ques;
      }
      this.value.detail.list.splice(index, 1);
    },
    change(vals) {
      console.log(this.valArray, "======");
      if (this.value.ext.edit) {
        this.value.detail.list.forEach((item, i) => {
          item.is_answer = 0;
        });
        vals.forEach((it) => {
          this.value.detail.list[it].is_answer = 1;
        });
      }
      this.errorTip = "";
      this.check();
    },
    itemFocus(item) {
      if (item.error) {
        item.error = false;
        item.value = "";
      }
    },
    check() {
      if (
        this.value.required === "Y" &&
        (!this.valArray || this.valArray.length === 0)
      ) {
        this.errorTip = this.$t("form.form_1083");
        return false;
      }
      if (
        this.value.required === "Y" &&
        this.value.detail.min > 0 &&
        this.valArray.length < this.value.detail.min
      ) {
        this.errorTip = this.$t("form.form_1092", {
          n: this.value.detail.min,
        });
        return false;
      }
      if (
        this.value.required === "Y" &&
        this.value.detail.max > 0 &&
        this.valArray.length > this.value.detail.max
      ) {
        this.errorTip = this.$t("form.form_1093", {
          n: this.value.detail.max,
        });
        return false;
      }
      let data = {
        id: this.value.id,
        value:
          this.valArray && this.valArray.length > 0
            ? this.valArray.join(",")
            : "",
      };

      // 按照答案顺序进行排序,不再按照用户勾选顺序排序
      let arr = [],
        sortarr = [];
      this.value.detail.list.forEach((item, ind) => {
        this.valArray.forEach((i) => {
          if (item.key == i) {
            arr.push({key: ind, val: i});
          }
        });
      });
      arr
        .sort((a, b) => {
          a.key - b.key;
        })
        .forEach((i) => {
          sortarr.push(i.val);
        });
      data.value = sortarr.join(",");

      // 自定义选项
      let flagobj = this.value.detail.list.find((item) => item.custom_opt == 1);

      if (flagobj && this.valArray.includes(flagobj.key) && this.otherValue) {
        data.value = data.value.replace(
          flagobj.key,
          `${flagobj.key}|${this.otherValue}|`,
        );
      }
      console.log(this.valArray, flagobj, data, "data");

      return data;
    },
    moved() {},
  },
  watch: {
    "value.detail.list": {
      handler(oldval, val) {
        this.valArray = [];
        val.forEach((item, ind) => {
          if (item.is_answer === 1) {
            this.valArray.push(ind);
          }
        });
      },
      deep: true,
    },
  },
  mounted() {
    //回显数据
    if (this.value.replayData) {
      let keys = this.value.replayData.split(",");
      for (let i = 0; i < keys.length; i++) {
        let others = keys[i].split("|");
        if (others.length > 1) {
          //存在 | 其他值
          this.otherValue = others[1];
          this.valArray.push(others[0]);
        } else {
          this.valArray.push(keys[i]);
        }
      }
    }
  },
};
</script>

<style scoped lang="scss">
.q-edit-content {
  .row {
    position: relative;
    .otherItem {
      margin-top: 15px;
      margin-bottom: 7px;
    }
    .remove {
      position: absolute;
      top: 8px;
      right: 8px;
      cursor: pointer;
      font-size: 20px;
      color: #606266;
      &:hover {
        color: #fc5659;
      }
    }

    &.row_edit {
      .sort-item {
        cursor: move;
        position: absolute;
        height: 40px;
        //padding-top: 5px;
        box-sizing: border-box;
        z-index: 2;
        left: 0;
        display: none;
        width: 24px;
        margin-top: -1px;
      }
      ::v-deep {
        .q-select-item {
          &:hover {
            .sort-item {
              display: flex;
              align-items: center;
            }
          }

          .vh-checkbox__input {
            //margin-top: 12px;
            position: absolute;
            left: 24px;
          }

          &.display {
            margin-bottom: 5px;

            .vh-checkbox__input {
              margin-top: 6px;
              //float: left;
              position: absolute;
              left: 24px;
            }
          }

          .vh-checkbox__label {
            padding-left: 55px;
          }
        }
      }
      .otherItem {
        &.com-input {
          padding-left: 65px;
        }
      }
    }
  }
  .row_edit {
    margin-bottom: 15px;
  }
  ::v-deep {
    .error-msg {
      position: absolute;
      color: #fc5659;
      padding-left: 10px;
      line-height: 20px;
      font-size: 12px;
    }
    .q-select-item {
      width: 100%;
      position: relative;
      .vh-checkbox__input {
        margin-top: 12px;
        float: left;
      }
      &.display {
        margin-bottom: 5px;
        .vh-checkbox__input {
          margin-top: 6px;
          float: left;
        }
      }
      .vh-checkbox__label {
        display: block;
        padding-right: 35px;
        padding-left: 24px;
        .com-input {
          margin-right: 8px;
          &.error {
            input {
              border-color: #fc5659;
              color: #fc5659;
            }
            .limit {
              display: none;
            }
          }
        }
      }
      .item-text {
        display: inline-block;
        font-size: 12px;
        margin-top: 5px;
        white-space: normal;
        word-wrap: break-word;
        word-break: break-word;
        overflow-wrap: break-word;
        font-weight: 400;
        line-height: 18px;
      }
    }

    .vh-checkbox__input.is-disabled.is-checked .vh-checkbox__inner {
      background-color: #bfbfbf;
      border-color: #bfbfbf;
    }

    .vh-checkbox__input.is-disabled.is-checked .vh-checkbox__inner::after {
      background-color: #bfbfbf !important;
    }
  }
}
</style>
